import React from 'react';
import makeStyles from 'shared/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: (props: { size?: number }) => props.size || 60,
    height: (props: { size?: number }) => (props.size ? (props.size * 2) / 3 : 40),
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  svg: {
    width: '100%',
    height: '100%',
  },
  blob: {
    animation: '$playful 1.5s ease-in-out infinite',
    transformOrigin: 'center',
  },
  blueBlob: {
    fill: '#42a5f5',
  },
  pinkBlob: {
    fill: '#ff8a8a',
  },
  face: {
    fill: '#1a1a1b',
  },
  blush: {
    fill: '#ff69b4',
    opacity: 0.4,
  },
  glasses: {
    fill: 'none',
    stroke: '#ffffff',
    strokeWidth: 2,
  },
  '@keyframes playful': {
    '0%, 100%': {
      transform: 'translateY(0) scale(1)',
    },
    '50%': {
      transform: 'translateY(-8px) scale(1.05, 0.95)',
    },
  },
}));

export interface PlayfulBlobsProps {
  size?: number;
  animated?: boolean;
}

export default function PlayfulBlobs(props: PlayfulBlobsProps) {
  const classes = useStyles(props);
  return (
    <div className={classes.container}>
      <svg
        className={classes.svg}
        viewBox="0 0 120 80"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Blue Blob */}
        <g
          className={props.animated ? classes.blob : ''}
        >
          <circle cx="40" cy="40" r="25" className={classes.blueBlob} />
          {/* Blush */}
          <circle cx="28" cy="42" r="4" className={classes.blush} />
          <circle cx="52" cy="42" r="4" className={classes.blush} />
          {/* Face */}
          <circle cx="35" cy="38" r="2.5" className={classes.face} />
          <circle cx="45" cy="38" r="2.5" className={classes.face} />
          <path d="M34 46 Q40 52 46 46" stroke="#1a1a1b" strokeWidth="2" fill="none" strokeLinecap="round" />
        </g>

        {/* Pink Blob */}
        <g
          className={props.animated ? classes.blob : ''}
          style={props.animated ? { animationDelay: '0.2s' } : {}}
        >
          <circle cx="80" cy="40" r="25" className={classes.pinkBlob} />
          {/* Blush */}
          <circle cx="68" cy="43" r="4" className={classes.blush} />
          <circle cx="92" cy="43" r="4" className={classes.blush} />
          {/* Glasses */}
          <circle cx="73" cy="38" r="7" className={classes.glasses} />
          <circle cx="87" cy="38" r="7" className={classes.glasses} />
          <line x1="80" y1="38" x2="80" y2="38" className={classes.glasses} />

          {/* Face */}
          <circle cx="73" cy="38" r="2" className={classes.face} />
          <circle cx="87" cy="38" r="2" className={classes.face} />
          <path d="M74 47 Q80 53 86 47" stroke="#1a1a1b" strokeWidth="2" fill="none" strokeLinecap="round" />
        </g>
      </svg>
    </div>
  );
}
